export const ANIMAL_NAMES = [
  "Albatross",
  "Dolphin",
  "Elephant",
  "Giraffe",
  "Koala",
  "Lion",
  "Penguin",
  "Squirrel",
  "Tiger",
  "Turtle",
  "Whale",
  "Zebra",
];

export const TOOL_NAMES = [
  "Axe",
  "Chisel",
  "Drill",
  "Hammer",
  "Mallet",
  "Pliers",
  "Saw",
  "Screwdriver",
  "Wrench",
  "Blowtorch",
  "Crowbar",
  "Ladder",
];

export const WESTERN_FIRST_NAMES = [
  "Adrian",
  "Albert",
  "Alexander",
  "Alice",
  "Amanda",
  "Amy",
  "Benjamin",
  "David",
  "Emma",
  "Esther",
  "Olivia",
  "Ruby",
  "Sarah",
  "Victoria",
];

export const WESTERN_LAST_NAMES = [
  "Anderson",
  "Brown",
  "Davis",
  "Jackson",
  "Johnson",
  "Jones",
  "Miller",
  "Moore",
  "Smith",
  "Taylor",
  "Thomas",
  "White",
  "Williams",
  "Wilson",
];

export const CYRILLIC_FIRST_NAMES = [
  "Абигаил",
  "Агнес",
  "Адам",
  "Адриан",
  "Алан",
  "Александр",
  "Алиса",
  "Альберт",
  "Аманда",
  "Амелия",
  "Эми",
  "Эндрю",
];

export const CYRILLIC_LAST_NAMES = [
  "Андерсон",
  "Браун",
  "Вилсон",
  "Джексон",
  "Джонс",
  "Джонсон",
  "Дэвис",
  "Миллер",
  "Мур",
  "Смит",
  "Тейлор",
  "Томас",
  "Уайт",
  "Уильямс",
];

export const JAPANESE_FIRST_NAMES = [
  "アグネス",
  "アダム",
  "アドリアン",
  "アビゲイル",
  "アマンダ",
  "アミー",
  "アメリア",
  "アラン",
  "アリス",
  "アルバート",
  "アレクサンダー",
  "アンドリュー",
];

export const JAPANESE_LAST_NAMES = [
  "アンダーソン",
  "ウィリアムズ",
  "ウィルソン",
  "ジャクソン",
  "ジョーンズ",
  "ジョンソン",
  "スミス",
  "タイラー",
  "デイビス",
  "トーマス",
  "ブラウン",
  "ホワイト",
  "ミラー",
  "モア",
];

export const ARABIC_FIRST_NAMES = [
  "آدريان",
  "آدم",
  "آلان",
  "آلبرت",
  "آليس",
  "آماندا",
  "آمي",
  "آميليا",
  "أبيجيل",
  "أغنيس",
  "ألكسندر",
  "أندرو",
];

export const ARABIC_LAST_NAMES = [
  "أندرسون",
  "براون",
  "تايلور",
  "توماس",
  "جاكسون",
  "جونز",
  "جونسون",
  "ديفيس",
  "سميث",
  "مور",
  "ميلر",
  "وايت",
  "ويلسون",
  "ويليامز",
];

export const FIRST_NAMES = [
  ...WESTERN_FIRST_NAMES,
  ...CYRILLIC_FIRST_NAMES,
  ...JAPANESE_FIRST_NAMES,
  ...ARABIC_FIRST_NAMES,
];

export const LAST_NAMES = [
  ...WESTERN_LAST_NAMES,
  ...CYRILLIC_LAST_NAMES,
  ...JAPANESE_LAST_NAMES,
  ...ARABIC_LAST_NAMES,
];
